module.exports = __webpack_public_path__ + "img/dp_lp_pc_kr_copy.e41eb5dd.png";